
import { ref, onMounted, SetupContext } from 'vue'
import { fetchDollarData } from '@/adapters/DataAPIAdapter'
import { fetchAndProcessDollarData } from '@/domain/usecases/FetchAndProcessDollarData'
import * as d3 from 'd3'
import * as XLSX from 'xlsx'

export default {
  name: 'DollarChart',
  setup (props:any, context: SetupContext) {
    const { emit } = context
    const data = ref<any[]>([])

    onMounted(async () => {
      data.value = await fetchAndProcessDollarData({ fetchDollarData })
      drawChart(data.value)
    })

    function downloadExcel () {
      const ws = XLSX.utils.json_to_sheet(data.value)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, 'Datos')
      XLSX.writeFile(wb, 'data.xlsx')
    }

    function drawChart (data: any[]) {
      const margin = { top: 20, right: 20, bottom: 50, left: 50 }
      const width = 400 - margin.left - margin.right
      const height = 200 - margin.top - margin.bottom

      const yAxisFormat = (domainValue: d3.NumberValue) => `${domainValue} CLP`
      // Create scale
      const extent = d3.extent(data, d => new Date(d.fecha)) as [Date, Date]
      const xScale = d3.scaleTime()
        .domain(extent)
        .range([0, width])
      const yScale = d3.scaleLinear()
        .domain([d3.min(data, d => d.variation), d3.max(data, d => d.variation)])
        .range([height, 0])

      // Create line
      const line = d3.line<{ fecha: string; variation: number }>()
        .x(d => xScale(new Date(d.fecha)))
        .y(d => yScale(d.variation))
      // ADD SVG to DOM
      const svg = d3.select('.svg-container')
        .append('svg')
        .attr('width', width + margin.left + margin.right)
        .attr('height', height + margin.top + margin.bottom)
        .append('g')
        .attr('transform', `translate(${margin.left}, ${margin.top})`)
        // X
      svg.append('g')
        .attr('transform', `translate(0, ${height})`)
        .call(d3.axisBottom(xScale))
        .append('text')
        .attr('x', width / 2)
        .attr('y', 40)
        .attr('fill', 'black')
        .style('text-anchor', 'middle')

      // Y
      svg.append('g')
        .call(d3.axisLeft(yScale).tickFormat(yAxisFormat))
        .append('text')
        .attr('x', 0)
        .attr('y', -30)
        .attr('fill', 'black')
        .style('text-anchor', 'middle')
      svg.append('path')
        .datum(data)
        .attr('fill', 'none')
        .attr('stroke', 'steelblue')
        .attr('stroke-width', 1.5)
        .attr('d', line)
    }

    function close () {
      emit('close')
    }

    return { close, downloadExcel }
  }
}
